export default {
  audience: "X-Audience",
  csrf: "X-CSRF-Token"
}